import React, { useState, useEffect } from 'react';
import Logo from '../../assets/new-logo.png';
import { supabase } from '../../supabaseClient'; // Import the Supabase client
import { EvaluationIcon, GoalsIcon, NoteIcon, PlantIcon, UserIcon, HomeIcon, SettingsIcon, LearningModulesIcon, EntriesIcon, UmbrellaIcon, RoleManagementIcon } from "../../assets/icons/icons"; // Import icons
import './style.css';

export default function NavBar(props) {
  // Nav Icon States
  const [isDashboard, setIsDashboard] = useState(false);
  const [isWrite, setIsWrite] = useState(false);
  const [isEntries, setIsEntries] = useState(false);
  const [isMyPlant, setIsMyPlant] = useState(false);
  const [isMyGoals, setIsMyGoals] = useState(false);
  const [isAccount, setIsAccount] = useState(false);
  const [isUserManagement, setIsUserManagement] = useState(false);
  const [isRoleManagement, setIsRoleManagement] = useState(false);

  const [isAuthenticated, setIsAuthenticated] = useState(false); // Check user login state

  const [isSideNav, setIsSideNav] = useState(true);

  const [userRole, setUserRole] = useState(localStorage.getItem("userRole"));
  const [username, setUsername] = useState("");
  const [userPermissions, setUserPermissions] = useState([]);

  // Helper to check if user has a specific permission
  const hasPermission = (permission) => {
    return userPermissions.includes(permission);
  };

  useEffect(() => {
    const checkAuthSession = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      setIsAuthenticated(!!sessionData.session); // Set isAuthenticated to true if a session exists

      // Load user permissions from localStorage
      const storedPermissions = localStorage.getItem("userPermissions");
      if (storedPermissions) {
        try {
          setUserPermissions(JSON.parse(storedPermissions));
        } catch (err) {
          console.error("Failed to parse userPermissions:", err);
          setUserPermissions([]);
        }
      }

      if (sessionData.session) {
        const { data: usr, error } = await supabase
          .from("users")
          .select("role")
          .eq("id", sessionData.session.user.id)
          .single();
        // if (!error && usr) {
        //     setUserRole(usr.role);
        // }

        const { data: profile, error: profileErr } = await supabase
          .from("profile_table")
          .select("username")
          .eq("id", sessionData.session.user.id)
          .single();
        if (!profileErr && profile?.username) {
          setUsername(profile.username);
        }
      }

      // If no session exists, ensure storage is clear
      if (!sessionData.session) {
        localStorage.removeItem("userRole");
        setUserRole(null);
      }
    };

    checkAuthSession();

    // Listen for Auth Changes (Sign In / Sign Out)
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setIsAuthenticated(!!session);

        if (event === "SIGNED_OUT" || !session) {
          // === CLEAR STORAGE ON LOGOUT ===
          localStorage.removeItem("userRole");
          localStorage.removeItem("userPermissions");
          setUserRole(null);
          setUsername("");
          setUserPermissions([]);
        }
      },
    );

    return () => {
      authListener.subscription?.unsubscribe();
    };
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setIsAuthenticated(false);
    window.location.href = "/"; // Redirect to home after logout
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    setIsDashboard(currentPath === "/");
    setIsWrite(currentPath === "/my-evaluation");
    setIsEntries(currentPath === "/learning-modules");
    setIsMyPlant(currentPath === "/umbrella-sharing");
    setIsMyGoals(currentPath === "/umbrella-sharing");
    setIsAccount(currentPath === "/account");
    setIsUserManagement(currentPath === "/user-management");
    setIsRoleManagement(currentPath === "/role-management");
  }, []);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 1100);
    window.addEventListener("resize", checkMobile);
    checkMobile();
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      {isMobile ? (
        <>
          <div className="mobile-view">
            <footer className="mobile-nav">
              <button
                className={`nav-icon-btn ${isDashboard ? "mobile-nav-selected" : ""}`}
                onClick={(e) => (window.location.href = "/")}
              >
                <HomeIcon className="icon" />
              </button>
              {hasPermission("Evaluation") && (
                <button
                  className={`nav-icon-btn ${isWrite ? "mobile-nav-selected" : ""}`}
                  onClick={(e) => (window.location.href = "/my-evaluation")}
                >
                  <EvaluationIcon className="icon" />
                </button>
              )}

              {/* Middle button for Entry Icon */}
              {/* <div className="entry-button-container">
                                <button
                                    className="entry-button"
                                    onClick={(e) => window.location.href = '/write'}
                                >
                                    <NoteIcon className="entry-icon" />
                                </button>
                            </div> */}

              {hasPermission('Learning module') && (
                <button
                  className={`nav-icon-btn ${isEntries ? 'mobile-nav-selected' : ''}`}
                  onClick={(e) => window.location.href = '/learning-modules'}
                >
                  <EntriesIcon className="icon" />
                </button>
              )}
              {hasPermission('User management') && (
                <button
                  className={`nav-icon-btn ${isUserManagement ? 'mobile-nav-selected' : ''}`}
                  onClick={(e) => window.location.href = '/user-management'}
                >
                  <UserIcon className="icon" />
                </button>
              )}
              {hasPermission('Role management') && (
                <button
                  className={`nav-icon-btn ${isRoleManagement ? 'mobile-nav-selected' : ''}`}
                  onClick={(e) => window.location.href = '/role-management'}
                >
                  <RoleManagementIcon className="icon" />
                </button>
              )}
              <button
                className={`nav-icon-btn ${isAccount ? 'mobile-nav-selected' : ''}`}
                onClick={(e) => window.location.href = '/account'}
              >
                <SettingsIcon className="icon" />
              </button>
            </footer>
          </div>
        </>
      ) : (
        <>
          <header className="header-dashboard">
            <nav className="web-nav">
              <div className="logo-container" onClick={() => window.location.href = '/'}>
                <img src={Logo} className="logo" alt="CalmLeaf Logo" />
                {/* <h1 className={`logo-text ${isSideNav ? '' : 'display-none'}`}></h1> */}
              </div>
              <div className="web-nav-icon-container">
                <div className='sidenav-container'>
                  {/* <div className={`icon-container ${isWrite ? 'nav-selected' : ''}`} onClick={() => window.location.href = '/write'}>
                                        <NoteIcon className="icon" />
                                        <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Write</span>
                                    </div> */}
                  {hasPermission("Evaluation") && (
                    <div
                      className={`icon-container ${isWrite ? "nav-selected" : ""}`}
                      onClick={() => (window.location.href = "/my-evaluation")}
                    >
                      <div className={`${isWrite ? "nav-icon-selected" : ""}`}>
                        <EvaluationIcon
                          className={`nav-icon ${isWrite ? "nav-icon-selected" : ""}`}
                        />
                      </div>
                      <span
                        className={`icon-title ${isSideNav ? "" : "nav-selected"}`}
                      >
                        Evaluations
                      </span>
                    </div>
                  )}
                  {hasPermission("Learning module") && (
                    <div
                      className={`icon-container ${isEntries ? "nav-selected" : ""}`}
                      onClick={() =>
                        (window.location.href = "/learning-modules")
                      }
                    >
                      <div
                        className={`${isEntries ? "nav-icon-selected" : ""}`}
                      >
                        <EntriesIcon
                          className={`nav-icon ${isEntries ? "nav-icon-selected" : "icon"}`}
                        />
                      </div>
                      <span
                        className={`icon-title ${isSideNav ? "" : "nav-selected"}`}
                      >
                        Learning
                      </span>
                    </div>
                  )}
                  {hasPermission("User management") && (
                    <div
                      className={`icon-container ${isUserManagement ? "nav-selected" : ""}`}
                      onClick={() =>
                        (window.location.href = "/user-management")
                      }
                    >
                      <div
                        className={`${isUserManagement ? "nav-icon-selected" : ""}`}
                      >
                        <UserIcon
                          className={`nav-icon ${isUserManagement ? "nav-icon-selected" : ""}`}
                        />
                      </div>
                      <span
                        className={`icon-title ${isSideNav ? "" : "nav-selected"}`}
                      >
                        User Management
                      </span>
                    </div>
                  )}
                  {hasPermission("Role management") && (
                    <div
                      className={`icon-container ${isRoleManagement ? "nav-selected" : ""}`}
                      onClick={() =>
                        (window.location.href = "/role-management")
                      }
                    >
                      <div
                        className={`${isRoleManagement ? "nav-icon-selected" : ""}`}
                      >
                        <RoleManagementIcon
                          className={`nav-icon ${isRoleManagement ? "nav-icon-selected" : ""}`}
                        />
                      </div>
                      <span
                        className={`icon-title ${isSideNav ? "" : "nav-selected"}`}
                      >
                        Role Management
                      </span>
                    </div>
                  )}
                  {/* <div className={`icon-container ${isMyGoals ? 'nav-selected' : ''}`} onClick={() => window.location.href = '/umbrella-sharing'}>
                                        <div className={`${isMyGoals ? 'nav-icon-selected' : ''}`}>
                                            <UmbrellaIcon className={`nav-icon ${isMyGoals ? 'nav-icon-selected' : ''}`} />
                                        </div>
                                        <span className={`icon-title ${isSideNav ? '' : 'nav-selected'}`}>Umbrella Sharing</span>
                                    </div> */}
                </div>
                <div>
                  {/* {isAuthenticated ? (
                                        <div className='icon-container' onClick={handleLogout}>
                                            <UserIcon className="nav-icon" />
                                            <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Logout</span>
                                        </div>
                                    ) : (
                                        <div className='icon-container' onClick={() => window.location.href = '/login'}>
                                            <UserIcon className="nav-icon" />
                                            <span className={`icon-title ${isSideNav ? '' : 'display-none'}`}>Login</span>
                                        </div>
                                    )} */}
                  <div
                    className={`icon-container ${isAccount ? "nav-selected" : ""}`}
                    onClick={() => (window.location.href = "/account")}
                  >
                    <div className={`${isAccount ? "nav-icon-selected" : ""}`}>
                      <SettingsIcon
                        className={`nav-icon ${isAccount ? "nav-icon-selected" : ""}`}
                      />
                    </div>
                    <span
                      className={`icon-title ${isSideNav ? "" : "nav-selected"}`}
                    >
                      Account
                    </span>
                  </div>
                  {isAuthenticated && username && (
                    <div className="icon-container">
                      <span
                        className={`icon-title ${isSideNav ? "" : "nav-selected"}`}
                      >
                        {username}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </nav>
          </header>
        </>
      )}
    </>
  );
}
